import PropTypes from "prop-types";
import { Ring } from "@uiball/loaders";

import { alignItems, colors, strCode } from "../../../../../consts";
import { t } from "../../../../../services";
import { historyLogsParserUtils } from "../../utils/historyLogsParserUtils";

import {
  FlexContainers,
  LogHistoryTable,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../../../components";
import { GenerateSection, ScrollContentWrapper } from "./styled";

export const DeviceCertificates = ({
  hasCertificate,
  deviceChangeHistory,
  loading,
  certificateInfoLoading,
  deviceChangeHistoryLoading,
  onGenerateCertificates,
  onDownloadCertificates,
  onRevokeCertificates
}) => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      width={"100%"}
      gap={16}>
      {certificateInfoLoading ? (
        <WrapperContainer Container={FlexContainers.FlexColumnCenter} width={"100%"} mt={24}>
          <Ring color={colors.RAISIN_100} size={48} lineWeight={4} speed={2} />
        </WrapperContainer>
      ) : (
        <>
          <GenerateSection Container={FlexContainers.FlexRowBetween} width={"100%"}>
            <WrapperContainer
              Container={FlexContainers.FlexColumn}
              alignItems={alignItems.start}
              width={"100%"}
              gap={8}>
              <Paragraph2>{t(strCode.GET_CERTIFICATE_TITLE)}</Paragraph2>
              <Paragraph2>
                {t(
                  hasCertificate
                    ? strCode.GENERATED_CERTIFICATE_DESCRIPTION
                    : strCode.GET_CERTIFICATE_DESCRIPTION
                )}
              </Paragraph2>
            </WrapperContainer>
            <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8} mt={8}>
              {hasCertificate ? (
                <>
                  <SmallButton
                    onClick={onRevokeCertificates}
                    disabled={loading}
                    secondary
                    isRedText>
                    {t(strCode.REVOKE_BTN)}
                  </SmallButton>
                  <SmallButton
                    onClick={onDownloadCertificates}
                    disabled={loading}
                    loading={loading}>
                    {t(strCode.DOWNLOAD_BTN)}
                  </SmallButton>
                </>
              ) : (
                <SmallButton onClick={onGenerateCertificates} disabled={loading} loading={loading}>
                  {t(strCode.GENERATE_BTN)}
                </SmallButton>
              )}
            </WrapperContainer>
          </GenerateSection>

          {deviceChangeHistoryLoading ? (
            <WrapperContainer
              Container={FlexContainers.FlexColumnCenter}
              width={"100%"}
              mt={24}
              textAlign={"center"}>
              <Paragraph2>{t(strCode.LOADING)}</Paragraph2>
            </WrapperContainer>
          ) : deviceChangeHistory?.length ? (
            <ScrollContentWrapper
              Container={FlexContainers.FlexColumnStart}
              width={"100%"}
              alignItems={alignItems.start}
              gap={4}>
              <Paragraph2>{t(strCode.HISTORY_TITLE)}</Paragraph2>

              <LogHistoryTable
                logs={deviceChangeHistory}
                parseLogs={historyLogsParserUtils.parseLogs}
                getLogAction={historyLogsParserUtils.getLogAction}
              />
            </ScrollContentWrapper>
          ) : null}
        </>
      )}
    </WrapperContainer>
  );
};

DeviceCertificates.propTypes = {
  hasCertificate: PropTypes.bool,
  deviceChangeHistory: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool.isRequired,
  certificateInfoLoading: PropTypes.bool.isRequired,
  deviceChangeHistoryLoading: PropTypes.bool,
  onGenerateCertificates: PropTypes.func.isRequired,
  onDownloadCertificates: PropTypes.func.isRequired,
  onRevokeCertificates: PropTypes.func.isRequired
};
